import { render, staticRenderFns } from "./OsInternalUsersByCustomerOverview.vue?vue&type=template&id=4fa8a7f4&scoped=true"
import script from "./OsInternalUsersByCustomerOverview.vue?vue&type=script&lang=ts"
export * from "./OsInternalUsersByCustomerOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa8a7f4",
  null
  
)

export default component.exports